var components
try {
  components = {
    uGap: function () {
      return import(
        /* webpackChunkName: "node-modules/uview-ui/components/u-gap/u-gap" */ "uview-ui/components/u-gap/u-gap.vue"
      )
    },
    uPopup: function () {
      return import(
        /* webpackChunkName: "node-modules/uview-ui/components/u-popup/u-popup" */ "uview-ui/components/u-popup/u-popup.vue"
      )
    },
    "u-Form": function () {
      return import(
        /* webpackChunkName: "node-modules/uview-ui/components/u--form/u--form" */ "uview-ui/components/u--form/u--form.vue"
      )
    },
    uFormItem: function () {
      return import(
        /* webpackChunkName: "node-modules/uview-ui/components/u-form-item/u-form-item" */ "uview-ui/components/u-form-item/u-form-item.vue"
      )
    },
    "u-Input": function () {
      return import(
        /* webpackChunkName: "node-modules/uview-ui/components/u--input/u--input" */ "uview-ui/components/u--input/u--input.vue"
      )
    },
    uIcon: function () {
      return import(
        /* webpackChunkName: "node-modules/uview-ui/components/u-icon/u-icon" */ "uview-ui/components/u-icon/u-icon.vue"
      )
    },
    "u-Textarea": function () {
      return import(
        /* webpackChunkName: "node-modules/uview-ui/components/u--textarea/u--textarea" */ "uview-ui/components/u--textarea/u--textarea.vue"
      )
    },
    uUpload: function () {
      return import(
        /* webpackChunkName: "node-modules/uview-ui/components/u-upload/u-upload" */ "uview-ui/components/u-upload/u-upload.vue"
      )
    },
    uModal: function () {
      return import(
        /* webpackChunkName: "node-modules/uview-ui/components/u-modal/u-modal" */ "uview-ui/components/u-modal/u-modal.vue"
      )
    },
  }
} catch (e) {
  if (
    e.message.indexOf("Cannot find module") !== -1 &&
    e.message.indexOf(".vue") !== -1
  ) {
    console.error(e.message)
    console.error("1. 排查组件名称拼写是否正确")
    console.error(
      "2. 排查组件是否符合 easycom 规范，文档：https://uniapp.dcloud.net.cn/collocation/pages?id=easycom"
    )
    console.error(
      "3. 若组件不符合 easycom 规范，需手动引入，并在 components 中注册该组件"
    )
  } else {
    throw e
  }
}
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  var m0 = _vm.info ? _vm.returnStatus(_vm.info.status) : null
  var g0 = _vm.info ? _vm.info.submitDate.substring(0, 16) : null
  var g1 = _vm.info ? _vm.info.happenTime.substring(0, 16) : null
  var l0 = _vm.info
    ? _vm.__map(_vm.info.logList, function (item, index) {
        var $orig = _vm.__get_orig(item)
        var g2 = _vm.info.logList.length
        var g3 = !(g2 === 1) ? _vm.info.logList.length : null
        var g4 = [0, 4].includes(item.objType)
        var g5 = !g4 ? [1, 2].includes(item.objType) : null
        return {
          $orig: $orig,
          g2: g2,
          g3: g3,
          g4: g4,
          g5: g5,
        }
      })
    : null
  if (!_vm._isMounted) {
    _vm.e0 = function ($event, item) {
      var _temp = arguments[arguments.length - 1].currentTarget.dataset,
        _temp2 = _temp.eventParams || _temp["event-params"],
        item = _temp2.item
      var _temp, _temp2
      _vm.previewImage(
        item.fileurlFull,
        _vm.info.multifileList.map(function (item) {
          return item.fileurlFull
        })
      )
    }
    _vm.e1 = function ($event, child, item) {
      var _temp3 = arguments[arguments.length - 1].currentTarget.dataset,
        _temp4 = _temp3.eventParams || _temp3["event-params"],
        child = _temp4.child,
        item = _temp4.item
      var _temp3, _temp4
      _vm.previewImage(
        child.fileurlFull,
        item.multifileList.map(function (item) {
          return item.fileurlFull
        })
      )
    }
    _vm.e2 = function ($event) {
      _vm.show2 = false
    }
  }
  _vm.$mp.data = Object.assign(
    {},
    {
      $root: {
        m0: m0,
        g0: g0,
        g1: g1,
        l0: l0,
      },
    }
  )
}
var recyclableRender = false
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns, recyclableRender, components }